import { useState, useEffect } from 'react';
import Drawer from '../../../../components/v2/Drawer.jsx';

const PreformNoteDrawer = ({ open, onClose, onSave, saving, editTarget }) => {
    const [note, setNote] = useState('');
    const [error, setError] = useState('');

    const isEdit = !!editTarget;

    // Reset form when drawer opens
    useEffect(() => {
        if (open) {
            setNote(editTarget?.preform_note || '');
            setError('');
        }
    }, [open, editTarget]);

    const handleSave = () => {
        if (!note.trim()) {
            setError('Note template is required.');
            return;
        }
        onSave({
            note: note.trim(),
            ...(isEdit ? { id: editTarget.preform_note_id } : {}),
        });
    };

    return (
        <>
            <Drawer
                open={open}
                onClose={onClose}
                title={isEdit ? 'Edit Note Template' : 'Add Note Template'}
                footer={(
                    <>
                        <button className="dp-btn dp-btn--cancel" onClick={onClose}>
                            Cancel
                        </button>
                        <button className="dp-btn dp-btn--primary" disabled={saving} onClick={handleSave}>
                            {saving ? (isEdit ? 'Saving...' : 'Adding...') : (isEdit ? 'Save Changes' : 'Add Template')}
                        </button>
                    </>
                )}
            >
                <div className="dp-drawer__field">
                    <label className="dp-drawer__label">
                        Note Template <span className="dp-drawer__required">*</span>
                    </label>
                    <textarea
                        className={`dp-drawer__input${error ? ' is-invalid' : ''}`}
                        style={{ height: '125px', resize: 'vertical', padding: 'var(--space-2) var(--space-3)' }}
                        value={note}
                        placeholder="Enter note template text"
                        onChange={(e) => {
                            setNote(e.target.value);
                            if (error) setError('');
                        }}
                    />
                    {error ? (
                        <p className="dp-drawer__error">{error}</p>
                    ) : null}
                </div>
            </Drawer>
        </>
    );
};

export default PreformNoteDrawer;
